/**
 * Internal dependencies
 */
import normalizeBlocks from "./normalize-blocks";

export default function divNormaliser(node) {
  if (node.nodeName !== "DIV") {
    return;
  }

  node.innerHTML = normalizeBlocks(node.innerHTML);
}
